<template>
  <mdb-navbar
    position="top"
    color="pentagon-navbar"
    dark
    :transparent="transparency"
    scrolling
    class="pentagon-navbar"
    :class="{
      'pentagon-navbar--solid': !transparency,
      'pentagon-navbar--scrolled': scrolled,
    }"
  >
    <mdb-navbar-brand to="/">
      <img
        class="pentagon-brand"
        src="/pentagon-logo.png"
        :alt="$t('navigation.brand_alt')"
      />
    </mdb-navbar-brand>
    <mdb-navbar-toggler>
      <mdb-navbar-nav left>
        <mdb-nav-item waves-fixed exact to="/">{{ $t('navigation.home') }}</mdb-nav-item>
        <mdb-nav-item waves-fixed to="/Leden">{{ $t('navigation.members') }}</mdb-nav-item>
        <mdb-nav-item waves-fixed to="/Bestuur">{{ $t('navigation.board') }}</mdb-nav-item>
        <mdb-nav-item waves-fixed to="/Gallerij">{{ $t('navigation.gallery') }}</mdb-nav-item>
        <mdb-nav-item
          waves-fixed
          href="/login"
          anchor-class="pentagon-nav-platform"
        >{{ $t('navigation.member_platform') }}</mdb-nav-item>
      </mdb-navbar-nav>
    </mdb-navbar-toggler>
  </mdb-navbar>
</template>

<script>
import {
  mdbNavbar,
  mdbNavbarToggler,
  mdbNavbarNav,
  mdbNavItem,
  mdbNavbarBrand,
} from 'mdbvue';

export default {
  name: 'NavBar',
  components: {
    mdbNavbar,
    mdbNavbarToggler,
    mdbNavbarNav,
    mdbNavItem,
    mdbNavbarBrand,
  },
  data() {
    return {
      scrolled: false,
    };
  },
  computed: {
    transparency() {
      return this.$store.state.navbar.transparent;
    },
  },
  mounted() {
    this.onScroll();
    window.addEventListener('scroll', this.onScroll, { passive: true });
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
  },
  methods: {
    onScroll() {
      this.scrolled = window.pageYOffset > 40;
    },
  },
};
</script>

<style lang="scss">
.pentagon-brand {
  height: 50px;
  width: 50px;
}

// Dark glass bar: transparent over the Home hero, ink once scrolled or on other pages.
.navbar.pentagon-navbar {
  background-color: transparent;
  border-bottom: 1px solid transparent;
  box-shadow: none;
  transition: background-color 0.4s, border-color 0.4s, padding 0.5s;

  &.pentagon-navbar--solid,
  &.pentagon-navbar--scrolled,
  &.top-nav-collapse {
    background-color: rgba(11, 10, 9, 0.82) !important;
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
  }

  &.pentagon-navbar--scrolled,
  &.top-nav-collapse {
    border-bottom-color: rgba(255, 215, 0, 0.45);
  }

  .navbar-nav .nav-item .nav-link {
    color: var(--pentagon-parchment);
    font-family: var(--pentagon-font-display);
    font-size: 0.95rem;
    font-weight: 600;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    transition: color 0.2s;

    &:hover,
    &.active {
      color: var(--pentagon-gold);
    }

    &.active {
      text-decoration: underline;
      text-decoration-color: rgba(255, 215, 0, 0.5);
      text-underline-offset: 0.45em;
    }
  }

  // mdbvue puts the toggler and the collapse after the brand; stated here so the navbar that
  // Laravel renders is laid out the same way.
  .navbar-toggler {
    order: 1;
    min-width: 44px;
    min-height: 44px;
    border-color: rgba(255, 215, 0, 0.35);
  }

  .navbar-collapse {
    order: 2;
  }
  .navbar-toggler:focus {
    outline: 2px solid var(--pentagon-gold);
    outline-offset: 2px;
  }

  @media (min-width: 992px) {
    .pentagon-nav-platform {
      margin-left: 0.5rem;
      border: 1px solid rgba(255, 215, 0, 0.55);
      border-radius: 2px;
    }
  }

  // The collapsed menu is a full-width ink panel with 44 px rows.
  @media (max-width: 991.98px) {
    .navbar-collapse {
      margin: 0.5rem -1rem 0;
      padding: 0 1rem 0.5rem;
      background-color: rgba(11, 10, 9, 0.96);
      border-top: 1px solid rgba(255, 215, 0, 0.25);
    }

    .navbar-nav .nav-item .nav-link {
      display: flex;
      align-items: center;
      min-height: 44px;
    }
  }
}
</style>
